import { render, staticRenderFns } from "./productItem.vue?vue&type=template&id=44bf5721&scoped=true&"
import script from "./productItem.vue?vue&type=script&lang=js&"
export * from "./productItem.vue?vue&type=script&lang=js&"
import style0 from "./productItem.vue?vue&type=style&index=0&id=44bf5721&scoped=true&lang=css&"
import style1 from "./productItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bf5721",
  null
  
)

export default component.exports